import React, { useState } from "react";
import styled from "styled-components";
import ceremonyImage from "./Images/Ceremony.png";
import "./App.css";

const DetailsContainer = styled.div`
  width: 100vw;
  height: 100%;
  min-height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;
  padding: 0 1rem;
  background-color: #f5e9dd;
`;

const DetailsWrapper = styled.div`
  background-color: rgb(255, 246, 237);
  backdrop-filter: blur(5px);
  border-radius: 10px;
  border: 1px solid #1c4587;
  border-image: url("data:image/svg+xml,%3csvg width='100' height='100' xmlns='http://www.w3.org/2000/svg'%3e%3cfilter id='noiseFilter'%3e%3cfeTurbulence type='fractalNoise' baseFrequency='1.2' numOctaves='4' stitchTiles='stitch'/%3e%3c/filter%3e%3crect width='100%25' height='100%25' filter='url(%23noiseFilter)' opacity='0.4'/%3e%3c/svg%3e")
    1;
  border-style: solid;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  justify-content: flex-start;
  align-items: center;
  text-align: center;
  display: flex;
  flex-direction: column;
  padding: 2rem;
`;

const TitleImage = styled.img`
  max-width: 150px;
  height: auto;
  margin-bottom: 1rem;
  flex-shrink: 0;
  opacity: ${(props) => (props.loaded ? 1 : 0)};
  transition: opacity 0.3s ease-in-out;
`;

const DetailsTitle = styled.h1`
  font-family: "Monsieur La Doulaise", cursive;
  font-size: 6vmin;
  text-align: center;
  margin-top: 0;
  margin-bottom: 1rem;
  flex-shrink: 0;
`;

const DetailsContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 900px;
`;

const Section = styled.div`
  padding: 1rem 0;
  text-align: center;
`;

const SectionDivider = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 1.5rem 0;

  &::before,
  &::after {
    content: "";
    flex: 1;
    height: 1px;
    background: linear-gradient(
      to var(--direction, right),
      transparent,
      rgba(139, 121, 94, 0.4) 50%,
      rgba(139, 121, 94, 0.4)
    );
  }

  &::before {
    --direction: right;
  }

  &::after {
    --direction: left;
  }

  span {
    padding: 0 1rem;
    font-family: "Monsieur La Doulaise", cursive;
    font-size: 1.8rem;
    color: rgba(139, 121, 94, 0.6);
  }
`;

const SectionTitle = styled.h2`
  font-family: "Monsieur La Doulaise", cursive;
  font-size: 2.5rem;
  margin-bottom: 1.5rem;
  margin-top: 0;
  text-align: center;
  color: #333;
`;

const SectionText = styled.p`
  font-family: "IM Fell English", serif;
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 1rem;
  text-align: center;

  &:last-child {
    margin-bottom: 0;
  }
`;

const SignatureText = styled.p`
  font-family: "Monsieur La Doulaise", cursive;
  font-size: 1.8rem;
  line-height: 1.6;
  margin-bottom: 1rem;
  text-align: center;

  &:last-child {
    margin-bottom: 0;
  }

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

const List = styled.ul`
  font-family: "IM Fell English", serif;
  font-size: 1rem;
  line-height: 1.8;
  text-align: left;
  margin: 1rem auto;
  padding-left: 1.5rem;
  max-width: 500px;

  li {
    margin-bottom: 0.5rem;
  }

  @media (max-width: 768px) {
    font-size: 0.95rem;
  }
`;

const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  margin-top: 1rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const InfoCard = styled.div`
  text-align: center;

  h4 {
    font-family: "IM Fell English", serif;
    font-size: 1.1rem;
    margin: 0 0 0.5rem 0;
    font-style: italic;
  }

  p {
    font-family: "IM Fell English", serif;
    font-size: 0.95rem;
    line-height: 1.5;
    margin: 0;
    color: #444;
  }

  a {
    color: #444;
    text-decoration: underline;
    transition: opacity 0.2s ease;

    &:hover {
      opacity: 0.7;
    }
  }
`;

const Details = () => {
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <DetailsContainer>
      <DetailsWrapper>
        <TitleImage
          src={ceremonyImage}
          alt="Ceremony"
          loaded={imageLoaded}
          onLoad={() => setImageLoaded(true)}
        />
        <DetailsTitle>The Details</DetailsTitle>
        <DetailsContent>
          <Section>
            <SectionText>
              First, a heartfelt thank you to everyone who filled in the
              Expression of Interest form. Your responses helped guide us to
              finding the perfect venue. We're thrilled to share that we'll be
              celebrating in Burgundy, France, in late June and early July.
              We've found a stunning private property that keeps our whole group
              together under one roof, complete with a pool, beautiful outdoor
              spaces, and more charm than we know what to do with. We know this
              is a significant journey, and we completely understand if it's not
              possible. For those who can make it, we cannot wait to share this
              with you! It is going to be a very special week.
            </SectionText>
            <SectionText>With so much love,</SectionText>
            <SignatureText>Chris & Claudia</SignatureText>
          </Section>

          <SectionDivider>
            <span>~</span>
          </SectionDivider>

          <Section>
            <SectionTitle>key information</SectionTitle>
            <InfoGrid>
              <InfoCard>
                <h4>WhatsApp Group</h4>
                <p>
                  Join our wedding WhatsApp group for updates, coordination, and
                  to connect with other guests.
                </p>
                <p style={{ marginTop: "0.5rem" }}>
                  <a
                    href="https://chat.whatsapp.com/Inncu8Fp1EM8Bf6L8iKFK1"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Join the Group
                  </a>
                </p>
              </InfoCard>
              <InfoCard>
                <h4>Dress Code</h4>
                <p>
                  Garden party elegance. Think flowy dresses, linen suits, and
                  comfortable yet stylish attire.
                </p>
                <p style={{ marginTop: "0.5rem" }}>
                  <a
                    href="https://au.pinterest.com/clauderoses/wedding-vibes/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View Pinterest Inspiration
                  </a>
                </p>
              </InfoCard>
            </InfoGrid>
          </Section>

          <SectionDivider>
            <span>~</span>
          </SectionDivider>

          <Section>
            <SectionTitle>come prepared</SectionTitle>
            <SectionText>
              For one week, a private château in the heart of Burgundy will be
              ours. Days are slow and sunny, evenings are long, and there is
              always something good to eat.
            </SectionText>
            <SectionText>
              We've put together a mood board for inspiration. Think effortless
              elegance for the days and something more considered for the
              evenings. Pack accordingly.
            </SectionText>
            <SectionText>
              Bring swimwear and shoes for the rocky banks of the natural river
              on the grounds, and a solid pair of walking shoes for strolling
              through the vineyards.
            </SectionText>
            <SectionText>
              We'll have the château stocked with the basics, but part of the
              joy of this corner of France is its markets. Exceptional produce,
              cheese, and wine at every turn. Arrive with euros in your pocket
              and treat a market run as part of the experience.
            </SectionText>
            <SectionText>
              A universal adapter is worth tucking in. France uses Type E plugs.
              Everything else has been seen to.
            </SectionText>
          </Section>
        </DetailsContent>
      </DetailsWrapper>
    </DetailsContainer>
  );
};

export default Details;
